// mapping modes
export class UVMapping {};